export default __webpack_public_path__ + "static/media/1387.2c989ad0.png";